import { jsxs as T, Fragment as j, jsx as a } from "react/jsx-runtime";
import { FormikContext as M } from "formik";
import { useCallback as S, useRef as q, forwardRef as m, useId as X, useContext as W } from "react";
import { useMultiStyleConfig as B, chakra as E } from "@chakra-ui/react";
import { c as G, a as V, b as U, g as Z, u as I, m as y, d as C, e as J, n as Q, S as Y, T as z } from "../../index-c6798772.js";
var g = (e, t = []) => ({
  parts: (...n) => {
    if (ee(t))
      return g(e, n);
    throw new Error("createAnatomy().parts(...) should only be called once. Did you mean to use .extendWith(...) ?");
  },
  extendWith: (...n) => g(e, [...t, ...n]),
  rename: (n) => g(n, t),
  keys: () => t,
  build: () => [...new Set(t)].reduce(
    (n, o) => Object.assign(n, {
      [o]: {
        selector: [
          `&[data-scope="${l(e)}"][data-part="${l(o)}"]`,
          `& [data-scope="${l(e)}"][data-part="${l(o)}"]`
        ].join(", "),
        attrs: { "data-scope": l(e), "data-part": l(o) }
      }
    }),
    {}
  )
}), l = (e) => e.replace(/([A-Z])([A-Z])/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase(), ee = (e) => e.length === 0, h = (e) => e ? "" : void 0, te = (e) => e.nodeType === Node.DOCUMENT_NODE, ne = (e) => e != null && e === e.window;
function oe(e) {
  return te(e) ? e : ne(e) ? e.document : (e == null ? void 0 : e.ownerDocument) ?? document;
}
function re(e) {
  const t = {
    getRootNode: (n) => {
      var o;
      return ((o = n.getRootNode) == null ? void 0 : o.call(n)) ?? document;
    },
    getDoc: (n) => oe(t.getRootNode(n)),
    getWin: (n) => t.getDoc(n).defaultView ?? window,
    getActiveElement: (n) => t.getDoc(n).activeElement,
    isActiveElement: (n, o) => o === t.getActiveElement(n),
    getById: (n, o) => t.getRootNode(n).getElementById(o),
    setValue: (n, o) => {
      if (n == null || o == null)
        return;
      const r = o.toString();
      n.value !== r && (n.value = o.toString());
    }
  };
  return { ...t, ...e };
}
var k = (e) => (e == null ? void 0 : e.constructor.name) === "Array", D = (e, t) => {
  if (Object.is(e, t))
    return !0;
  if (e == null && t != null || e != null && t == null)
    return !1;
  if (typeof (e == null ? void 0 : e.isEqual) == "function" && typeof (t == null ? void 0 : t.isEqual) == "function")
    return e.isEqual(t);
  if (typeof e == "function" && typeof t == "function")
    return e.toString() === t.toString();
  if (k(e) && k(t))
    return Array.from(e).toString() === Array.from(t).toString();
  if (typeof e != "object" || typeof t != "object")
    return !1;
  const n = Object.keys(t ?? /* @__PURE__ */ Object.create(null)), o = n.length;
  for (let r = 0; r < o; r++)
    if (!Reflect.has(e, n[r]))
      return !1;
  for (let r = 0; r < o; r++) {
    const i = n[r];
    if (!D(e[i], t[i]))
      return !1;
  }
  return !0;
};
function x(e) {
  if (!ie(e) || e === void 0)
    return e;
  const t = Reflect.ownKeys(e).filter((o) => typeof o == "string"), n = {};
  for (const o of t) {
    const r = e[o];
    r !== void 0 && (n[o] = x(r));
  }
  return n;
}
var ie = (e) => e && typeof e == "object" && e.constructor === Object;
const ce = () => (e, t) => t.reduce(
  (n, o) => {
    const [r, i] = n, c = o;
    return i[c] !== void 0 && (r[c] = i[c]), delete i[c], [r, i];
  },
  [{}, { ...e }]
), [Oe, se] = G({
  name: "EnvironmentContext",
  hookName: "useEnvironmentContext",
  providerName: "<EnvironmentProvider />",
  strict: !1
});
function de(e, t = {}) {
  const { sync: n = !1 } = t, o = ae(e);
  return S(
    (...r) => {
      var i;
      return n ? queueMicrotask(() => {
        var c;
        return (c = o.current) == null ? void 0 : c.call(o, ...r);
      }) : (i = o.current) == null ? void 0 : i.call(o, ...r);
    },
    [n, o]
  );
}
function ae(e) {
  const t = q(e);
  return t.current = e, t;
}
const ue = (e) => typeof e == "function", le = (e, ...t) => ue(e) ? e(...t) : e;
function he(e, t, n) {
  if (!e)
    return;
  const o = e.ownerDocument.defaultView || window, r = new o.MutationObserver((i) => {
    for (const c of i)
      c.type === "attributes" && c.attributeName && t.includes(c.attributeName) && n(c);
  });
  return r.observe(e, { attributes: !0, attributeFilter: t }), () => r.disconnect();
}
var fe = {
  border: "0",
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: "0",
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}, P = (e) => e.ownerDocument.defaultView || window;
function pe(e, t) {
  const { type: n = "HTMLInputElement", property: o = "value" } = t, r = P(e)[n].prototype;
  return Object.getOwnPropertyDescriptor(r, o) ?? {};
}
function ge(e, t) {
  var o;
  (o = pe(e, { type: "HTMLInputElement", property: "checked" }).set) == null || o.call(e, t);
}
function me(e, t) {
  const { checked: n, bubbles: o = !0 } = t;
  if (!e)
    return;
  const r = P(e);
  e instanceof r.HTMLInputElement && (ge(e, n), e.dispatchEvent(new r.Event("click", { bubbles: o })), e.dispatchEvent(new r.Event("change", { bubbles: o })));
}
function ve(e) {
  return Ee(e) ? e.form : e.closest("form");
}
function Ee(e) {
  return e.matches("textarea, input, select, button");
}
function ye(e, t) {
  if (!e)
    return;
  const n = ve(e);
  return n == null || n.addEventListener("reset", t, { passive: !0 }), () => {
    n == null || n.removeEventListener("reset", t);
  };
}
function Ce(e, t) {
  const n = e == null ? void 0 : e.closest("fieldset");
  if (n)
    return t(n.disabled), he(n, ["disabled"], () => t(n.disabled));
}
function ke(e, t) {
  if (!e)
    return;
  const { onFieldsetDisabledChange: n, onFormReset: o } = t, r = [ye(e, o), Ce(e, n)];
  return () => {
    r.forEach((i) => i == null ? void 0 : i());
  };
}
var be = g("switch").parts("root", "label", "control", "thumb"), p = be.build(), d = re({
  getRootId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.root) ?? `switch:${e.id}`;
  },
  getLabelId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.label) ?? `switch:${e.id}:label`;
  },
  getThumbId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.thumb) ?? `switch:${e.id}:thumb`;
  },
  getControlId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.control) ?? `switch:${e.id}:control`;
  },
  getHiddenInputId: (e) => {
    var t;
    return ((t = e.ids) == null ? void 0 : t.input) ?? `switch:${e.id}:input`;
  },
  getHiddenInputEl: (e) => d.getById(e, d.getHiddenInputId(e))
});
function we(e, t, n) {
  const o = e.context.isDisabled, r = !o && e.context.focused, i = e.context.checked, c = {
    "data-active": h(e.context.active),
    "data-focus": h(r),
    "data-hover": h(e.context.hovered),
    "data-disabled": h(o),
    "data-state": e.context.checked ? "checked" : "unchecked",
    "data-invalid": h(e.context.invalid)
  };
  return {
    isChecked: i,
    isDisabled: o,
    isFocused: r,
    setChecked(s) {
      t({ type: "CHECKED.SET", checked: s, isTrusted: !1 });
    },
    toggleChecked() {
      t({ type: "CHECKED.TOGGLE", checked: i, isTrusted: !1 });
    },
    rootProps: n.label({
      ...p.root.attrs,
      ...c,
      dir: e.context.dir,
      id: d.getRootId(e.context),
      htmlFor: d.getHiddenInputId(e.context),
      onPointerMove() {
        o || t({ type: "CONTEXT.SET", context: { hovered: !0 } });
      },
      onPointerLeave() {
        o || t({ type: "CONTEXT.SET", context: { hovered: !1 } });
      },
      onPointerDown(s) {
        o || (r && s.preventDefault(), t({ type: "CONTEXT.SET", context: { active: !0 } }));
      },
      onPointerUp() {
        o || t({ type: "CONTEXT.SET", context: { active: !1 } });
      },
      onClick(s) {
        s.target === d.getHiddenInputEl(e.context) && s.stopPropagation();
      }
    }),
    labelProps: n.element({
      ...p.label.attrs,
      ...c,
      dir: e.context.dir,
      id: d.getLabelId(e.context)
    }),
    thumbProps: n.element({
      ...p.thumb.attrs,
      ...c,
      dir: e.context.dir,
      id: d.getThumbId(e.context),
      "aria-hidden": !0
    }),
    controlProps: n.element({
      ...p.control.attrs,
      ...c,
      dir: e.context.dir,
      id: d.getControlId(e.context),
      "aria-hidden": !0
    }),
    hiddenInputProps: n.input({
      id: d.getHiddenInputId(e.context),
      type: "checkbox",
      required: e.context.required,
      defaultChecked: i,
      disabled: o,
      "aria-labelledby": d.getLabelId(e.context),
      "aria-invalid": e.context.invalid,
      name: e.context.name,
      form: e.context.form,
      value: e.context.value,
      style: fe,
      onChange(s) {
        const v = s.currentTarget.checked;
        t({ type: "CHECKED.SET", checked: v, isTrusted: !0 });
      },
      onBlur() {
        t({ type: "CONTEXT.SET", context: { focused: !1 } });
      },
      onFocus() {
        t({ type: "CONTEXT.SET", context: { focused: !0 } });
      },
      onKeyDown(s) {
        s.key === " " && t({ type: "CONTEXT.SET", context: { active: !0 } });
      },
      onKeyUp(s) {
        s.key === " " && t({ type: "CONTEXT.SET", context: { active: !1 } });
      }
    })
  };
}
var { not: b } = Z;
function Te(e) {
  const t = x(e);
  return V(
    {
      id: "switch",
      initial: "ready",
      context: {
        checked: !1,
        label: "switch",
        value: "on",
        disabled: !1,
        ...t,
        fieldsetDisabled: !1
      },
      computed: {
        isDisabled: (n) => n.disabled || n.fieldsetDisabled
      },
      watch: {
        disabled: "removeFocusIfNeeded",
        checked: "syncInputElement"
      },
      activities: ["trackFormControlState"],
      on: {
        "CHECKED.TOGGLE": [
          {
            guard: b("isTrusted"),
            actions: ["toggleChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["toggleChecked"]
          }
        ],
        "CHECKED.SET": [
          {
            guard: b("isTrusted"),
            actions: ["setChecked", "dispatchChangeEvent"]
          },
          {
            actions: ["setChecked"]
          }
        ],
        "CONTEXT.SET": {
          actions: ["setContext"]
        }
      },
      states: {
        ready: {}
      }
    },
    {
      guards: {
        isTrusted: (n, o) => !!o.isTrusted
      },
      activities: {
        trackFormControlState(n, o, { send: r, initialContext: i }) {
          return ke(d.getHiddenInputEl(n), {
            onFieldsetDisabledChange(c) {
              n.fieldsetDisabled = c;
            },
            onFormReset() {
              r({ type: "CHECKED.SET", checked: !!i.checked, src: "form-reset" });
            }
          });
        }
      },
      actions: {
        setContext(n, o) {
          Object.assign(n, o.context);
        },
        syncInputElement(n) {
          const o = d.getHiddenInputEl(n);
          o && (o.checked = !!n.checked);
        },
        removeFocusIfNeeded(n) {
          n.disabled && n.focused && (n.focused = !1);
        },
        setChecked(n, o) {
          w.checked(n, o.checked);
        },
        toggleChecked(n, o) {
          w.checked(n, !n.checked);
        },
        dispatchChangeEvent(n) {
          const o = d.getHiddenInputEl(n);
          me(o, { checked: n.checked });
        }
      }
    }
  );
}
var Se = {
  change: (e) => {
    var t;
    (t = e.onCheckedChange) == null || t.call(e, { checked: e.checked });
  }
}, w = {
  checked: (e, t) => {
    D(e.checked, t) || (e.checked = t, Se.change(e));
  }
};
U()([
  "checked",
  "dir",
  "disabled",
  "form",
  "getRootNode",
  "id",
  "ids",
  "invalid",
  "label",
  "name",
  "onCheckedChange",
  "required",
  "value"
]);
const N = m((e, t) => {
  const n = I(), o = y(n.controlProps, e);
  return /* @__PURE__ */ T(j, { children: [
    /* @__PURE__ */ a(C.span, { ...o, ref: t }),
    /* @__PURE__ */ a("input", { ...n.hiddenInputProps })
  ] });
});
N.displayName = "SwitchControl";
const Ie = (e) => {
  const t = {
    id: X(),
    getRootNode: se(),
    ...e,
    checked: e.defaultChecked
  }, n = {
    ...t,
    checked: e.checked,
    onCheckedChange: de(e.onCheckedChange, { sync: !0 })
  }, [o, r] = J(Te(t), { context: n });
  return we(o, r, Q);
}, F = m((e, t) => {
  const [n, { children: o, ...r }] = ce()(e, [
    "checked",
    "defaultChecked",
    "dir",
    "disabled",
    "form",
    "getRootNode",
    "id",
    "ids",
    "invalid",
    "label",
    "name",
    "onCheckedChange",
    "required",
    "value"
  ]), i = Ie(n), c = y(i.rootProps, r), s = le(o, i);
  return /* @__PURE__ */ a(Y, { value: i, children: /* @__PURE__ */ a(C.label, { ...c, ref: t, children: s }) });
});
F.displayName = "SwitchRoot";
const O = m((e, t) => {
  const n = I(), o = y(n.thumbProps, e);
  return /* @__PURE__ */ a(C.span, { ...o, ref: t });
});
O.displayName = "SwitchThumb";
const He = m(
  ({
    checked: e,
    dataTestId: t,
    description: n,
    isDisabled: o,
    label: r,
    name: i,
    onChange: c,
    position: s = "left",
    size: v,
    tooltip: H,
    trackId: A,
    variant: R
  }, L) => {
    const u = W(M), $ = u && i ? u == null ? void 0 : u.getFieldProps(i) : {}, f = B("Toggle", { size: v, variant: R }), K = S((_) => {
      c == null || c(_.checked);
    }, []);
    return /* @__PURE__ */ T(
      E.div,
      {
        __css: f.root,
        as: F,
        checked: e !== void 0 ? e : i && (u == null ? void 0 : u.values[i]),
        disabled: o,
        name: i,
        onCheckedChange: K,
        ref: L,
        ...$,
        children: [
          /* @__PURE__ */ a(
            E.div,
            {
              "track-id": A,
              "data-testid": t,
              order: s === "left" ? 0 : 1,
              as: N,
              __css: f.control,
              children: /* @__PURE__ */ a(E.div, { as: O, __css: f.thumb })
            }
          ),
          /* @__PURE__ */ a(z, { label: r, description: n, tooltip: H, style: f })
        ]
      }
    );
  }
);
export {
  He as Toggle
};
//# sourceMappingURL=Toggle.container.es.js.map
